var api = require("!./target/scala-2.13/scalajs-bundler/main/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!./target/scala-2.13/scalajs-bundler/main/node_modules/css-loader/dist/cjs.js?url=false!./target/scala-2.13/scalajs-bundler/main/node_modules/sass-loader/dist/cjs.js??ref--6-2!./styles.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;